import { render, staticRenderFns } from "./msg-management.vue?vue&type=template&id=237dd1f8&scoped=true"
import script from "./msg-management.vue?vue&type=script&lang=js"
export * from "./msg-management.vue?vue&type=script&lang=js"
import style0 from "./msg-management.vue?vue&type=style&index=0&id=237dd1f8&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "237dd1f8",
  null
  
)

export default component.exports